import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';

function NormalFlowDraftToOnCreditsYesIncomplete(props) {
  const { postingId } = props;
  const temporalRedirect = () => {
    window.location = `/publicarPasoPublicacion.bum?idaviso=${postingId}`;
  };

  useEffect(() => {
    sendTrackingInfo('Mis avisos', 'Publicar Aviso con Datos incompletos_con credito-Intencion');
    temporalRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}

export { NormalFlowDraftToOnCreditsYesIncomplete };
